export default function languages() { 
    let $languages = $(".languages");

    if ($languages.length > 1) {
        $languages.eq(1).on("click", function() {
            $(this).toggleClass("active");
        });
    }

        console.log("asasas");
     
}
